import dayjs from 'dayjs'

export const utclocalts = (utcdate) => { // ej: '1609185108'
    const utcoffset = dayjs().utcOffset()
    if (utcoffset < 0) {
        return dayjs.unix(utcdate).subtract(Math.abs(utcoffset), 'minute').unix()
    } else {
        return dayjs.unix(utcdate).add(utcoffset, 'minute').unix()
    }
}

export const utclocaliso = (utcisostring) => { // ej: '2020-12-29T12:30:00'
    const utcoffset = dayjs().utcOffset()
    if (utcoffset < 0) {
        return dayjs(utcisostring).subtract(Math.abs(utcoffset), 'minute').format()
    } else {
        return dayjs(utcisostring).add(utcoffset, 'minute').format()
    }
}